import { createFileRoute } from "@tanstack/react-router";
import { ErrorState } from "@/ui/States";
import { useService } from "@/features/services/useService";
import { ScalePanel } from "@/features/services/ScalePanel";
import { MetricsPanel } from "@/features/observability/MetricsPanel";
import { DiagnosticsPanel } from "@/features/observability/DiagnosticsPanel";

export const Route = createFileRoute(
  "/_app/o/$orgId/projects/$projectId/services/$serviceId/",
)({
  component: ServiceOverview,
});

function ServiceOverview() {
  const { orgId, projectId, serviceId } = Route.useParams();
  const service = useService(orgId, projectId, serviceId);

  if (service.isError) {
    return <ErrorState error={service.error} onRetry={() => void service.refetch()} />;
  }
  const svc = service.data?.service;
  if (!svc) return null;

  return (
    <div className="flex flex-col gap-7">
      {/* The address and the facts are not here any more.
          They are in the spine, which is beside this tab rather than above
          it, and which stays put while somebody reads the logs. Printing
          them here as well would be the same four facts twice on one
          screen. */}
      {/* What a stopped service means, without a second Start button.
          There was one here and another in the header, three hundred pixels
          apart and doing the same thing — which reads as two different
          actions and makes somebody stop to work out which. The header's is
          the one that stays put across every tab, so it is the one that
          stays. */}
      {svc.desired_state === "STOPPED" && (
        <p className="t-body card-inset px-5 py-3">
          <span className="t-strong">This service is not running.</span> A
          stopped service keeps its configuration and costs nothing to keep.
        </p>
      )}

      <DiagnosticsPanel orgId={orgId} projectId={projectId} serviceId={serviceId} />

      <MetricsPanel orgId={orgId} projectId={projectId} serviceId={serviceId} />

      {/* Size and copies, after the evidence rather than before it.
          These are the two controls somebody reaches for when a service is
          struggling at two in the afternoon, and they used to be behind the
          Settings tab under a form that also held the Dockerfile target —
          which is the right place for a Dockerfile target and the wrong place
          for this. Bringing them onto the overview was right; putting them
          at the top of it was not. You decide to resize by looking at the
          load, so the load comes first and the lever sits underneath it. */}
      <ScalePanel
        orgId={orgId}
        projectId={projectId}
        service={svc}
        onSaved={() => void service.refetch()}
      />
    </div>
  );
}
